import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter, Renderer2,  ElementRef, ViewChild, AfterViewInit, AfterViewChecked, ChangeDetectorRef, HostListener   } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as $ from 'jquery';
import { SearchQueryModel } from '../../models/query.model';
import { SearchModelV2 } from '../../models/search-model-v2';
import { AppConfig } from '../../visa';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';


@Component({
  selector: 'app-advanced-search-general',
  templateUrl: './advanced-search-general.component.html',
  styleUrls: ['./advanced-search-general.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancedSearchGeneralComponent implements AfterViewInit  {
  @ViewChild('basic', { static: true }) basicInput: ElementRef;
  private _container: ElementRef;

  @ViewChild('container', { static: false }) set containerRef(value: ElementRef) {
    if (value) {
      this._container = value;
      this.setContainerWidth();
    }
  }

  @Input() advSearchModel: SearchModelV2;
  @Input() id: string;
  @Input() showAdv: boolean;
  @Input() readPermissionDefintion;
  @Input() appletSettings?: any;

  @Output() search = new EventEmitter<SearchQueryModel>();

  isAdvanced: boolean;
  inputArray: any[];
  advForm: FormGroup;
  optionArray = {};
  filter = '';
  apiVisa = AppConfig.apiVisa;
  basicInputWidth = 0;
  isChecked = false;
  isIndeterminate = false;

  companyGuid: string;
  companyGuidList: any[];

  constructor(private formBuilder: FormBuilder,
    private readonly store: Store<SessionStates>,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2) {
    this.isAdvanced = false;
    if (!this.showAdv) {
      this.showAdv = true;
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent): void {
    this.isAdvanced = false;
  }

  ngAfterViewInit() {
    if (this._container) {
      this.setContainerWidth();
    }
  }

  setContainerWidth() {
    if (this._container && this._container.nativeElement) {
      this.basicInputWidth = this.basicInput.nativeElement.offsetWidth + 65;
      this.renderer.setStyle(this._container.nativeElement, 'width', `${this.basicInputWidth}px`);
    } else {
      console.error('Container element or basicInput is not defined.');
    }
  }


  ngOnInit() {
    if (!this.advSearchModel) {
      this.advSearchModel = {
        label: 'keyword',
        dataType: 'string',
        form: new FormGroup({
          itemCode: new FormControl()
          }),
        options: {}
      }
    }

    let keysToDelete = Object.entries(this.advSearchModel?.dataType)
    .filter(([key, value]) => {
      // Check if the setting is false for specific keys before filtering out
      return (
        (value === 'select-multi-gl-dimension' && !this.appletSettings?.SHOW_GL_DIMENSION) ||
        (value === 'select-multi-segment' && !this.appletSettings?.SHOW_SEGMENT) ||
        (value === 'select-multi-profit-center' && !this.appletSettings?.SHOW_PROFIT_CENTER) ||
        (value === 'select-multi-project' && !this.appletSettings?.SHOW_PROJECT)
      );
    })
    .map(([key]) => key);
    if(keysToDelete?.length > 0 ){
      this.advSearchModel = {
        label: this.filterObject(this.advSearchModel.label, keysToDelete),
        dataType: this.filterObject(this.advSearchModel.dataType, keysToDelete),
        form: this.advSearchModel.form, // Keep the form as it is, without changes
        options: this.filterObject(this.advSearchModel.options, keysToDelete)
      };
    }
    
    this.advForm = this.advSearchModel.form;
    this.inputArray = Object.entries(this.advSearchModel.dataType).map((e: any) => e.flatMap(f => f));

    this.extractOptions();
    this.addCheckbox();
    for (const x of this.inputArray) {
      if(this.isCheckbox(x)){
        const checkboxName = x[0];
        //console.log('checkboxName',checkboxName)
        const initialValue = this.advSearchModel.options[checkboxName]?.checked || false;
        //console.log('initialValue',initialValue)
        const dynamicControlName = `${checkboxName}Checkbox`;
        this.advForm.patchValue({
          [dynamicControlName]: initialValue
        })
      }
    }

    // get personal settings
    this.store.select(SessionSelectors.selectPersonalSettings).subscribe((paSettings) => { 
      const key =  this.id + 'AdvancedSearch';
      if (paSettings[key])
      this.advForm.patchValue(paSettings[key]);  
    });

    $(document).mouseup( ev => {
      const container = $(`#${this.id}`);
      const calendar = $('mat-calendar');
      const matOption = $('mat-option');
      const backdrop = $('.cdk-overlay-backdrop');
      if (!matOption.is(ev.target) && !calendar.is(ev.target) && !container.is(ev.target) && !backdrop.is(ev.target)
          && matOption.has(ev.target).length === 0
          && container.has(ev.target).length === 0
          && calendar.has(ev.target).length === 0
          && backdrop.has(ev.target).length === 0) {
        container.hide('fast' , 'swing', c => {
          this.isAdvanced = false;
          // this.advForm.reset();
        });
      }
    });
  }

  // Helper function to filter out keys from an object
  filterObject(object: any, keysToDelete: string[]): any {
    return Object.fromEntries(Object.entries(object).filter(([key]) => !keysToDelete.includes(key)));
  }

  extractOptions = (fieldName?, fieldValue?) => this.inputArray
    .filter(x => x[1] === 'select')
    .filter(x => fieldName ? x[0] === fieldName : true)
    .forEach(x => {
      const options = x[2]
        .flatMap(e => e)
        .filter(e => fieldValue ? e.toLowerCase().includes(fieldValue.toLowerCase()) : true);
      this.optionArray[x[0]] = options;
    })

  searchToggle() {
    if (this.showAdv) {
      const container = $(`#${this.id}`);
      if (!this.isAdvanced) {
        this.isAdvanced = true;
        container.show('fast', 'swing', c => this.isAdvanced = true);
      }
    }
  }

  reset() {
    this.advForm.reset();
  }

  optionSearchFilter(query) {
    const fieldName = query.target.parentNode.parentNode.id;
    this.extractOptions(fieldName, query.target.value);
  }

  basicSearch(keyword: string) {
    console.log(keyword);
    const container = $(`#${this.id}`);
    const query = {
      queryString: "",
      keyword: keyword,
      isEmpty: !keyword
    };
    this.search.emit(query);
    container.hide('fast' , 'swing', c => {
      this.isAdvanced = false;
      // this.advForm.reset();
    });
  }

  advancedSearch() {
    const container = $(`#${this.id}`);
    const query = {
      queryString: this.advForm.value,
      keyword: "",
      isEmpty: false
    };

    const key =  this.id + 'AdvancedSearch';
    const settings = {
      settings: {
        [key]: this.advForm.value
      }
    } 

    this.store.dispatch(
      SessionActions.savePersonalSettingsInitNoPopup(settings)
    );

    this.search.emit(query);
    container.hide('fast' , 'swing', c => {
      this.isAdvanced = false;
      // this.advForm.reset();
    });
  }

  isRequired(x) {
    let value = this.advSearchModel.options[x[0]]['required'];
    return this.isTrue(value);
  }

  isMultiple(x) {
    let value = this.advSearchModel.options[x[0]]['multiple'];
    return this.isTrue(value);
  }

  isCheckbox(x) {
    let value = this.advSearchModel.options[x[0]]['checkbox'];
    return this.isTrue(value);
  }

  isTrue(value) {
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  addCheckbox() {
    this.inputArray.forEach(x => {
      if (this.isCheckbox(x)) {
        const checkbox = this.formBuilder.control(false);
        const name = x[0] + 'Checkbox';
        this.advForm.addControl(name, checkbox);
      }
    })
  }

  customWidth(x) {
    let customWidth = ((this.basicInputWidth-56) / 2);
    if (this.isCheckbox(x)) {
      customWidth += -15;
    }
    return customWidth + 'px';
  }

  checkForScrollBar() {
    const content = this._container.nativeElement;
    const hasScrollBar = content.scrollHeight > content.clientHeight;
    if (hasScrollBar) {
      console.log('Scroll bar exists');
    } else {
      console.log('No scroll bar');
    }
  }

  onCompanySelected(e: any[]) {
    if (e && e.length > 0) {
      this.companyGuid = e.length === 1 ? e[0].guid : null;
      this.companyGuidList = e.map(company => company.guid);
    } else {
      this.companyGuid = null;
      this.companyGuidList = [];
    }
  }

  onDateOptionChange(event: any): void {
    const selectedValue = event.value;
    console.log("Selected Date Option: ", selectedValue);
  }

  toggleSelectAll(isChecked: boolean, optionKey: string) {
    this.isChecked = isChecked;
    this.isIndeterminate = false;

    if (isChecked) {
      const selectedItems = this.optionArray[optionKey] || [];
      this.advForm.controls[optionKey].patchValue(selectedItems);
    } else {
      this.advForm.controls[optionKey].patchValue([]);
    }
  }
}
